import { BCMSCurrency, BrandingStyle, DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle } from "components/custom-ui/CustomAccordion";
import CustomSelect, { CustomAccountSelect, CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from 'components/custom-ui/DateSelect';
import { FormContainer, FormRowView } from 'components/shared';
import IconToggle from "components/shared/views/IconToggle";
import { UIAmountInput, UITextInput } from 'components/ui';
import { SVGAsset } from "res";

/**
 * @function TASPositivePayImportChecksUsingTemplateMobileView
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Add Check mobile content view.
 */
export default function TASPositivePayImportChecksUsingTemplateMobileView(props) {
    const { data, ui, onDesktopChange, onMobileChange } = useStateManager();
    const checkForms = data.checkForms;

    const typeItems = data.itemTypeCodes.reduce((acc, item) => {
        acc.push(
          <CustomSelectItem key={ item.id } value={ item.itemTypeMappingValue }>
            { item.itemTypeMapping }
          </CustomSelectItem>
        );
        return acc;
      }, []);

    const rows = checkForms.reduce((acc, item, index) => {
        const uiItem = ui.checkForms.filter(_item => _item.id === item.id)[0];
        const chevronIconClosedClass = uiItem.mobile.isActive ? "" : "closed";
        const amount = item.amount ? BCMSCurrency.init(item.amount).format() : undefined;
        const editingAmount = item.amount ? item.amount.amount : undefined;
        const accountError = item.account ? false : true;
        const accountClasses = accountError ? { className: "select-error"} : {};

        acc.push(
            <div key={ item.id } className="tas-positive-pay-import-checks-using-template-mobile-view show-on-mobile">
                <div className="flex-container align-top">
                    <CustomAccordion isOpen={ uiItem.mobile.isActive }>
                        <div className="flex-container flex-horizontal align-top check-custom-accordion-content">
                                <div className="set-width">
                                    <CustomAccordionToggle className={ "search" } onClick={ onMobileChange(item.id, "mobile") }>
                                        <IconToggle className={ `chevron-icon-container ${ chevronIconClosedClass }`} icon="DownChevronIcon" text=""/>
                                    </CustomAccordionToggle>
                                </div>
                                <div className="flex-width">
                                    <div className="flex-container flex-vertical check-details">
                                        <div className="check-detail-row">
                                            <span className="sub-text">Row: </span>
                                            <b>{ index + 1}</b>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="sub-text">Account: </span>
                                            <b>{ `undefined xundefined` }</b>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="sub-text">Issued Date: </span>
                                            <b>{ item.issuedDate.format("m/d/y") }</b>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="sub-text">Check Number: </span>
                                            <b>{ item.checkNumber }</b>
                                        </div>
                                        <div className="check-detail-row">
                                            <span className="sub-text">Amount: </span>
                                            <b>{ amount }</b>
                                        </div>
                                        { accountError
                                        && <div className="error-alert-info-container">
                                            <SVGAsset id="AlertTriangleIcon" className="" />
                                            <span>{ `Tap to view error(s)` }</span>
                                        </div>
                                        }
                                    </div>
                                </div>
                        </div>
                        { item.mobileViewIsEditing && 
                        <CustomAccordionContent className="flex-container flex-vertical tas-positive-pay-add-check-page-accordion-content">
                            <CustomAccordionToggle className="flex-container flex-width close-accordion accordion-edit-view" onClick={ onMobileChange(item.id, "mobile") }>
                                <BrandingStyle className="flex-width sub-text" element={<p >EDIT CHECK</p>}/>
                                <SVGAsset className="icon set-width" id="CloseX" data-point="CloseButton" />
                            </CustomAccordionToggle>
                            <FormContainer className="small-form-width">
                                <FormRowView text="Account">
                                    <CustomAccountSelect { ...accountClasses} value={ item.account } accounts={ data.accounts } active={ uiItem.account.isActive }
                                    onChange={ onDesktopChange(item.id, "account") }/>
                                </FormRowView>
                                <FormRowView text="Issued Date">
                                <DateSelect enablePast={ true } 
                                value={ item.issuedDate } active={ uiItem.issuedDate.isActive } onChange={ onDesktopChange(item.id, "issuedDate") }/>
                                </FormRowView>
                                <FormRowView text="Check Number">
                                    <UITextInput value={ item.checkNumber } onChange={ onDesktopChange(item.id, "checkNumber") } />
                                </FormRowView>
                                <FormRowView text="Amount">
                                    <UIAmountInput className="amount-field" value={ editingAmount } showClearButton={ false } onChange={ onDesktopChange(item.id, "amount") } />
                                </FormRowView>
                                <FormRowView text="Payee">
                                    <UITextInput value={ item.payee } onChange={ onDesktopChange(item.id, "payee") } />
                                </FormRowView>
                                <FormRowView text="Reference Number">
                                    <UITextInput value={ item.referenceNumber } onChange={ onDesktopChange(item.id, "referenceNumber") } />
                                </FormRowView>
                                <FormRowView className="type-form-view" text="Type">
                                <CustomSelect value={ item.type } active={ uiItem.type.isActive }
                                onChange={ onDesktopChange(item.id, "type") }>
                                    { typeItems }
                                </CustomSelect>
                                </FormRowView>
                                <div className="flex-container flex-vertical">
                                    <DisabledPrompt>
                                        <a className="clickable delete">Delete</a>
                                    </DisabledPrompt>
                                </div>
                            </FormContainer>
                        </CustomAccordionContent>
                        }
                    </CustomAccordion>
                </div>
            </div>
        );
        return acc;
    }, [])
    
    return rows;
}